@if (icon(); as icon) {
  <div class="icon-container">
    <nb-icon [config]="icon"></nb-icon>
  </div>
}

<div class="content-container">
  @if (title(); as title) {
    <span class="title">{{ title }}</span>
  }
  <div class="message">{{ message() }}</div>
</div>
